import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { StudentAttendanceThisYearTab } from '@features/student-page/components/StudentAttendanceThisYearTab'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/students/$studentNo/attendance/this-year')({
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'This year',
        },
    },
})

function RouteComponent() {
    const { studentNo } = Route.useParams()

    return (
        <QueryErrorBoundary title="Failed to load student attendance for this year">
            <Suspense fallback={<LoadingIndicator resource="attendance for this academic year" />}>
                <StudentAttendanceThisYearTab studentNo={studentNo} />
            </Suspense>
        </QueryErrorBoundary>
    )
}
